export default __webpack_public_path__ + "963bc8842a3fa252a3aed33e3db195f0.svg";